var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
export var slotify = function slotify(rawChildren, slotMap) {
  var serializedConfig = Object.entries(slotMap);
  var slots = serializedConfig.reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      slotKey = _ref2[0];
    acc[slotKey] = {
      slotProps: {},
      slotChildren: null,
      slotRef: null
    };
    return acc;
  }, {});
  React.Children.toArray(rawChildren).forEach(function (child) {
    var slot = child;
    if (!slot || !slot.type) {
      return;
    }
    var slotConfig = serializedConfig.find(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        type = _ref4[1];
      return slot.type === type;
    });
    if (!slotConfig) {
      return;
    }
    var _slotConfig = _slicedToArray(slotConfig, 1),
      slotKey = _slotConfig[0];
    var _slot$props = slot.props,
      children = _slot$props.children,
      props = _objectWithoutProperties(_slot$props, _excluded);
    slots[slotKey] = {
      slotChildren: children,
      slotProps: props,
      slotRef: slot.ref
    };
  });
  return slots;
};
//# sourceMappingURL=slotify.js.map